/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract Unity",
                name: "token",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receivedTokenAddress",
                type: "address",
            },
        ],
        name: "InvalidTokenContract",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "UTYTokenReceived",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "callMint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "onUTYTokenReceived",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b506040516102a53803806102a583398101604081905261002f91610054565b600080546001600160a01b0319166001600160a01b0392909216919091179055610084565b60006020828403121561006657600080fd5b81516001600160a01b038116811461007d57600080fd5b9392505050565b610212806100936000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c8063a9372cfd1461003b578063abb381cb14610050575b600080fd5b61004e610049366004610176565b610063565b005b61004e61005e3660046101a0565b6100cd565b6000546040516340c10f1960e01b81526001600160a01b03848116600483015260248201849052909116906340c10f1990604401600060405180830381600087803b1580156100b157600080fd5b505af11580156100c5573d6000803e3d6000fd5b505050505050565b60005433906001600160a01b031681146101095760405163265b0f7b60e01b81526001600160a01b038216600482015260240160405180910390fd5b604080516001600160a01b038087168252851660208201529081018390527f9a8623161f584dfcced2abc5830edf6c28c4405fe1d30b61410042d00dc272679060600160405180910390a150505050565b80356001600160a01b038116811461017157600080fd5b919050565b6000806040838503121561018957600080fd5b6101928361015a565b946020939093013593505050565b6000806000606084860312156101b557600080fd5b6101be8461015a565b92506101cc6020850161015a565b915060408401359050925092509256fea2646970667358221220e7bf54d7379bccb98029f7225a606d073c8045026f2e404d54dec259a04b0afb64736f6c63430008180033";
const isSuperArgs = (xs) => xs.length > 1;
export class UTYReceiver__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(token, overrides) {
        return super.getDeployTransaction(token, overrides || {});
    }
    deploy(token, overrides) {
        return super.deploy(token, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
UTYReceiver__factory.bytecode = _bytecode;
UTYReceiver__factory.abi = _abi;
//# sourceMappingURL=UTYReceiver__factory.js.map